export const GET_ALL_SEARCH = 'GET_ALL_SEARCH'
export const GET_ALL_PAST_SEARCH = 'GET_ALL_PAST_SEARCH'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_DASHBOARD = 'GET_ALL_DASHBOARD'
